import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { useReactToPrint } from "react-to-print";
import moment from "moment/moment";
import DatePicker from "react-date-picker";
import Loader from "../../shared/loader";
import Swal from "sweetalert2";
import axios from "axios";
import Select from "react-select";

const Payment = () => {
  const contentToPrint = useRef(null);
  const [paymentData, setPaymentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isCustomPrint, setIsCustomPrint] = useState(true);
  const [partyId, setPartyId] = useState(0);
  const [salesManDrp, setSalesManDrp] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const selectRef = useRef();

  const getSalesManData = () => {
    axios.post(API_URL.PARTY_LIST, { status: 1 }).then((res) => {
      if (res?.data?.data?.length > 0) {
        let pt = res.data.data.map((raw) => {
          return {
            label: raw.name,
            value: raw.id,
          };
        });
        setSalesManDrp(pt);
      }
    });
  };

  const searchDataByDate = (fromDate, toDate) => {
    if (fromDate && toDate) {
      setLoading(true);
      getData(partyId, fromDate, toDate);
    }
    if (!fromDate && !toDate) {
      setLoading(true);
      getData(partyId, null, null);
    }
  };

  const customPrint = () => {
    setIsCustomPrint(false);
  };

  const clearFilter = () => {
    setLoading(false);
    setStartDate(null);
    setEndDate(null);
    setPaymentData([]);
    setPartyId(0);
    setTimeout(() => {
      selectRef.current.clearValue();
    }, 200);
  };

  const getData = (party_id, from_date, to_date) => {
    let params = {
      user_id: party_id,
      from_date: from_date ? moment(from_date).format("YYYY-MM-DD") : null,
      to_date: to_date ? moment(to_date).format("YYYY-MM-DD") : null,
    };
    axios.post(API_URL.PAYMENT_LIST, params).then(
      (res) => {
        if (res.data.status === 1) {
          setPaymentData(res.data.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          position: "top-right",
        });
      }
    );
  };

  const deleteData = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.PAYMENT_DELETE, { id: row.id }).then(
          (res) => {
            toast.success("Purchase Deleted Successfully.", {
              autoClose: 3000,
              position: "top-right",
            });
            setLoading(true);
            getData(partyId, startDate, endDate);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-right",
            });
          }
        );
      }
    });
  };

  const handlePrint = useReactToPrint({
    documentTitle: "",
    onBeforePrint: () => {
      console.log("before printing...");
    },
    onAfterPrint: () => {
      setIsCustomPrint(true);
    },
    removeAfterPrint: true,
  });


  useEffect(() => {
    !isCustomPrint && handlePrint(null, () => contentToPrint.current);
  }, [isCustomPrint]);

  useEffect(() => {
    if (partyId && partyId > 0) {
      setLoading(true);
      getData(partyId, startDate, endDate);
    }
  }, [partyId]);

  useEffect(() => {
    getSalesManData();
  }, []);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <div className="d-flex">
            <h5 className="me-1">Payment </h5>
            <small className="me-2"> ({paymentData.length})</small>
          </div>
          <div className="d-flex align-items-center">
            <Link to={"/admin/payment/add"}>
              <button className="btn btn-sm btn-primary ">
                <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>Payment
              </button>
            </Link>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <div className="form-group">
            <Select
              ref={selectRef}
              placeholder={"Select Party"}
              value={salesManDrp.find((pt) => pt.value == partyId)}
              options={salesManDrp}
              onChange={(e) => setPartyId(e ? e.value : 0)}
            />
          </div>
        </div>
        <div className="col-md-3 col-sm-12">
          <div className="form-group">
            <DatePicker
              placeholderText="From Date"
              dateFormat="dd/MM/yyyy"
              className="form-control input-sm"
              selected={startDate}
              clearIcon={startDate ? undefined : null}
              onChange={(date) => [
                setStartDate(date),
                searchDataByDate(date, endDate),
              ]}
              value={startDate}
            />
          </div>
        </div>
        <div className="col-md-3 mb-1 col-sm-12">
          <div className="form-group">
            <DatePicker
              placeholderText="To Date"
              dateFormat="dd/MM/yyyy"
              className="form-control input-sm"
              selected={endDate}
              clearIcon={endDate ? undefined : null}
              onChange={(date) => [
                setEndDate(date),
                searchDataByDate(startDate, date),
              ]}
              value={endDate}
            />
          </div>
        </div>
        <div className="col-md-3 col-sm-12 text-end">
          {(partyId || startDate || endDate) && (
            <button
              type="button"
              className="btn btn-danger me-2"
              onClick={clearFilter}
            >
              <i class="fa-solid fa-xmark me-2"></i>
              Clear Filter
            </button>
          )}
          <button
            type="button"
            disabled={!partyId || !paymentData.length}
            className="btn btn-primary"
            onClick={() => customPrint()}
          >
            <i class="fa-solid fa-arrow-down me-2"></i>
            Download
          </button>

        </div>
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
              {loading && <Loader></Loader>}
              {!loading && paymentData.length > 0 &&
                <div className="table-responsive" ref={contentToPrint}>
                  <table className="table table-center table-hover datatable">
                    <thead className="thead-light">
                      <tr>
                        <th style={{ width: 120 }}>Date</th>
                        <th style={{ width: 170 }}>Amount</th>
                        <th style={{ width: 170 }}>Type</th>
                        <th>Remark</th>
                        {isCustomPrint ? (
                          <th style={{ width: 200 }} className="action-th"></th>
                        ) : null}
                      </tr>
                    </thead>
                    <tbody>
                      {paymentData.map((row, key) => {
                        return (
                          <tr key={key} style={{ height: "40px" }}>
                            <td>
                              {moment(row.date, "YYYY-MM-DD").format("DD-MM-YYYY")}
                            </td>
                            <td>{row.amount}</td>
                            <td>{(row.payment_type == 'Paid') ? 'For Invoice' : 'Received'}</td>
                            <td>{row.remark}</td>
                            {isCustomPrint ? (
                              <td className="d-flex justify-content-end gap-3">
                                <Link to={"/admin/payment/edit/" + row.id}>
                                  <i className="fa fa-edit"></i>
                                </Link>
                                <i onClick={() => deleteData(row)} className="fa fa-trash-alt"></i>
                              </td>
                            ) : null}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>}
              {!loading && paymentData.length === 0 && <div className="d-flex justify-content-center info-text">No Data Found. Please select any pary name...</div>}
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default Payment;
